/** Weighted quota allocation via the largest-remainder method.
 *
 * Splits `total` across items proportionally to `weight`, guaranteeing the
 * quotas sum exactly to `total` (floors first, then the largest fractional
 * remainders absorb the leftover units). Same method as the backend seeder.
 */
export function largestRemainder<T extends { weight: number }>(
  items: T[],
  total: number,
): number[] {
  const weightSum = items.reduce((s, it) => s + it.weight, 0) || 1;
  const exact = items.map((it) => (it.weight / weightSum) * total);
  const floors = exact.map(Math.floor);
  let leftover = total - floors.reduce((s, f) => s + f, 0);

  const order = exact
    .map((x, i) => ({ i, frac: x - Math.floor(x) }))
    .sort((a, b) => b.frac - a.frac);

  const result = [...floors];
  for (const { i } of order) {
    if (leftover <= 0) break;
    result[i] += 1;
    leftover -= 1;
  }
  return result;
}
